import { Link } from 'react-router-dom';
import { t } from 'i18next';
import type { CSSProperties } from 'react';
import { useMarqueeAnimation } from '../hooks/useMarqueeAnimation';

interface LinkCardItemProps {
  title: string;
  description: string;
  navigateTo?: string;
  className?: string;
  style?: CSSProperties;
  rightContent?: React.ReactNode;
  onClick?: () => void;
}

const LinkCardItem = ({
  title,
  description,
  navigateTo,
  className,
  style,
  rightContent,
  onClick
}: LinkCardItemProps) => {
  const { shouldAnimate, textRef, containerRef } = useMarqueeAnimation(description);

  const commonClassName = `relative flex flex-col items-start justify-end leading-tight gap-[3px] w-[248px] h-[134px] pb-[23px] pl-[22px] rounded-[18px] shadow-[0_0_18.949px_0_rgba(255,255,255,0.55)_inset] ${className}`;

  const content = (
    <>
      {rightContent}
      <p className="text-[17px] font-bold">{t(title)}</p>
      <div className="overflow-hidden w-full" ref={containerRef}>
        <p
          className="text-[14px] font-medium whitespace-nowrap text-left"
          ref={textRef}
          style={{ animation: shouldAnimate ? 'marquee-bounce-short 6s linear infinite' : 'none' }}
        >
          {t(description)}
        </p>
      </div>
    </>
  );

  if (navigateTo && !onClick) {
    // navigateTo가 있으면 Link, 없으면 button(onClick)으로 렌더링
    return (
      <Link to={navigateTo} className={commonClassName} style={style}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" className={commonClassName} style={style} onClick={onClick}>
      {content}
    </button>
  );
};

export default LinkCardItem;
